<!-- Info icon revealing a field hint on hover/focus. -->
<template>
  <span class="relative group inline-flex items-center align-middle" tabindex="0">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-4 h-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 cursor-pointer"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </svg>
    <span
      role="tooltip"
      class="pointer-events-none absolute left-1/2 -translate-x-1/2 bottom-full mb-1.5 w-56 rounded-md px-3 py-2 text-xs font-normal leading-snug text-left glass-card opacity-0 transition-opacity duration-150 z-20 whitespace-normal group-hover:opacity-100 group-focus:opacity-100"
    >
      {{ text }}
    </span>
  </span>
</template>

<script>
export default {
  name: "FieldHelp",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>
